import { render, staticRenderFns } from "./BrandChannelForm.vue?vue&type=template&id=6436f2dc"
import script from "./BrandChannelForm.vue?vue&type=script&lang=js"
export * from "./BrandChannelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports